import QueryString from 'qs'

import { putRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'
import { SimpleResult } from '../../types/PaginatedResult'
import { SClassified } from '../../types/api/Classified'
import { classifiedTransformer } from '../../transformers/classifiedTransformer'
import { Status } from '../../types/Classified'

type HideResponse = SimpleResult<SClassified>

export type HideParams = {
  id: number
}

const hide = ({ id }: HideParams) => {
  return putRestRequest({
    url:
      api.REST_API_URL +
      `/classifieds/${id}?${QueryString.stringify({
        populate: {
          classifiedCategory: {
            fields: ['name', 'form'],
          },
        },
      })}`,
    data: {
      data: {
        classifiedStatus: Status.Hidden,
        hiddenAt: new Date(),
      },
    },
    transformer: (response: HideResponse) => {
      return classifiedTransformer(response.data)
    },
  })
}

export default hide
